import { z } from 'zod';
import { ProdutoCategoriaSchema } from '@/features/produto-categoria/types/ProdutoCategoria';
import { ProdutoMarcaSchema } from '@/features/produto-marca/types/ProdutoMarca';
import { ProdutoComposicaoSchema } from './ProdutoComposicao';
import { ProdutoEstoqueSchema } from './ProdutoEstoque';
import { ProdutoFieldsSchema } from './ProdutoFields';
import { ProdutoFotoSchema } from './ProdutoFoto';
import { ProdutoLoteSchema } from './ProdutoLote';
import { ProdutoOrigemSchema } from './ProdutoOrigem';
import { ProdutoPacoteBarraSchema } from './ProdutoPacoteBarra';
import { ProdutoProdutoAdicionalSchema } from './ProdutoProdutoAdicional';
import { ProdutoTabelaPrecoSchema } from './ProdutoTabelaPreco';
import { ProdutoTipoFiscalSchema } from './ProdutoTipoFiscal';
import { ProdutoUnidadeSchema } from './ProdutoUnidade';
import { ProdutoVariacaoSchema } from './ProdutoVariacao';
import { ProdutoVendaExternaEstoqueSchema } from './ProdutoVendaExternaEstoque';

export const ProdutoSchema = ProdutoFieldsSchema.extend({
    adicional: ProdutoProdutoAdicionalSchema.array().nullable(),
    estoque_total: z.number(),
    lote: ProdutoLoteSchema.array().nullable(),
    produto_categoria: ProdutoCategoriaSchema.nullable(),
    produto_composicao: ProdutoComposicaoSchema.array().nullable(),
    produto_estoque: ProdutoEstoqueSchema.array().nullable(),
    produto_foto: ProdutoFotoSchema.array().nullable(),
    produto_marca: ProdutoMarcaSchema.omit({ qtde_produtos: true }).nullable(),
    produto_origem: ProdutoOrigemSchema.nullable(),
    produto_pacote_barra: ProdutoPacoteBarraSchema.array().nullable(),
    produto_tipo: ProdutoTipoFiscalSchema.nullable(),
    produto_unidade: ProdutoUnidadeSchema.nullable(),
    tabela_preco: ProdutoTabelaPrecoSchema.nullish(), // Se informado idpk da tabela de preço
    variacao: ProdutoVariacaoSchema.nullable(),
    venda_externa_estoque: ProdutoVendaExternaEstoqueSchema.nullish(), // Se informado idpk da venda externa
});

export type Produto = z.infer<typeof ProdutoSchema>;
